var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsOptional, IsUUID } from 'class-validator';
import { PatientBookingPayerContext } from '../booking-intake.js';
/**
 * Patient request for free slots for a NEW non-GKV episode (PRD #1343, RS-008).
 * Unlike the plan-backed search there is no plan to resolve continuity from: the
 * patient picked a payer context and one treatment concept, and the search runs
 * across all therapists of the patient's own office location (resolved
 * server-side from the token) with a standard duration. The redacted projection
 * (free times only, no therapist name — "egal") is returned.
 */
export class FindPatientFirstContactSlotsDto {
    payerContext;
    treatmentConceptId;
    /** Earliest day to search from (defaults to "today" server-side when omitted). */
    searchFrom;
}
__decorate([
    IsEnum(PatientBookingPayerContext),
    __metadata("design:type", String)
], FindPatientFirstContactSlotsDto.prototype, "payerContext", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindPatientFirstContactSlotsDto.prototype, "treatmentConceptId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientFirstContactSlotsDto.prototype, "searchFrom", void 0);
//# sourceMappingURL=find-patient-first-contact-slots.dto.js.map